import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.SoilGrainSize`]: 'Soil Grain Size',
      [`${prefix}.Preparation.TareMass`]: 'Tare Mass',
      [`${prefix}.Preparation.TarePlusSampledMass`]: 'Tare and Sampled Mass',
      [`${prefix}.Preparation.SampledMass`]: 'Sampled Mass',
      [`${prefix}.Preparation.ContainsGypsum`]: 'Sample contains gypsum',

      [`${prefix}.Equipment.DryingTemperature`]: 'Drying Temperature',
      [`${prefix}.Equipment.Balance`]: 'Preparation Balance',
      [`${prefix}.Equipment.RoomThermometer`]: 'Room Thermometer',
      [`${prefix}.Equipment.MeasurementBalance`]: 'Balance',
      [`${prefix}.Equipment.TestThermometer`]: 'Test Thermometer',
      [`${prefix}.Equipment.Clock`]: 'Clock',
      [`${prefix}.Equipment.MechanicalShaker`]: 'Shaker',
      [`${prefix}.Equipment.DryMassBalance`]: 'Drying Balance',
      [`${prefix}.Equipment.Oven`]: 'Drying Oven',

      [`${prefix}.Measurements.MinimumRoomTemperature`]: 'Minimum Room Temperature',
      [`${prefix}.Measurements.MaximumRoomTemperature`]: 'Maximum Room Temperature',
      [`${prefix}.Measurements.RoomTemperatureRange`]: 'Room Temperature Range',
      [`${prefix}.Measurements.TestMeasurements.SpecimenId`]: 'Specimen ID',
      [`${prefix}.Measurements.TestMeasurements.Pycnometer`]: 'Gas Jar ID',
      [`${prefix}.Measurements.TestMeasurements.EmptyGasJarAndLidMass`]: 'Empty Gas Jar & Lid Mass',
      [`${prefix}.Measurements.TestMeasurements.GasJarLidAndSpecimenMass`]: 'Gas Jar, Lid & Specimen Mass',
      [`${prefix}.Measurements.TestMeasurements.SoakingStartTime`]: 'Soaking Started',
      [`${prefix}.Measurements.TestMeasurements.SoakingEndTime`]: 'Soaking Ended',
      [`${prefix}.Measurements.TestMeasurements.SoakingPeriod`]: 'Soaking Period',
      [`${prefix}.Measurements.TestMeasurements.ShakingStartTime`]: 'Shaking Started',
      [`${prefix}.Measurements.TestMeasurements.ShakingEndTime`]: 'Shaking Ended',
      [`${prefix}.Measurements.TestMeasurements.ShakingPeriod`]: 'Shaking Period',
      [`${prefix}.Measurements.TestMeasurements.GasJarLidSpecimenAndWaterMass`]: 'Gas Jar, Lid, Specimen & Water Mass',
      [`${prefix}.Measurements.TestMeasurements.WaterTemperature1`]: 'Water Temperature 1',
      [`${prefix}.Measurements.TestMeasurements.GasJarLidAndWaterMass`]: 'Gas Jar, Lid & Water Mass',
      [`${prefix}.Measurements.TestMeasurements.WaterTemperature2`]: 'Water Temperature 2',
      [`${prefix}.Measurements.TestMeasurements.ParticleDensity`]: 'Particle Density',
      [`${prefix}.Measurements.TestMeasurements.ExcludeTest`]: 'Exclude Test',

      [`${prefix}.Results.AvgParticleDensity`]: 'Particle Density',
      [`${prefix}.Results.MaterialRetainedOn37_5mmSieve`]: 'Retained 37.5 mm Sieve',
      [`${prefix}.Results.MaterialRetainedOn50_0mmSieve`]: 'Retained 50 mm Sieve',
      [`${prefix}.Results.SievingMethod`]: 'Sieving Method',
      [`${prefix}.Results.ReportSievingResults`]: 'Sieving Results',

      [`${prefix}.TestPortions.MoistureDetermination.DryingTray.ConstantDrySoilMass`]: 'Specimen Dry Mass',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Measurements.RoomTemperatureRange`]: '°C',
      [`${prefix}.Results.MaterialRetainedOn37_5mmSieve`]: '%',
      [`${prefix}.Results.MaterialRetainedOn50_0mmSieve`]: '%',
    })
  );

export default getLabelConfig;
